import moment from 'moment'

import { ActiveFooter } from './ActiveFooter'
import { DefaultFooter } from './DefaultFooter'
import { RejoinFooter } from './RejoinFooter'

export function getModalHeader(membershipData) {
  if (membershipData?.startDate) {
    return {
      title: `THIS MONTH YOU SAVED: $${membershipData.accumulatedSavings || 0}`,
      subtitle: !membershipData.stopDate
        ? `Current benefits period: ${formatMembershipDate(
            membershipData.startDate
          )} to ${formatMembershipDate(membershipData.endDate)}`
        : `Your Unity Pass has been canceled — current benefits will expire
    after ${formatMembershipDate(membershipData.endDate)}`
    }
  }
  return {
    title: 'Save at least $10 on',
    highlighted: 'every order!',
    subtitle:
      'Become a Unity Pass holder and start enjoying amazing benefits everytime you order. Here’s what you get:'
  }
}

export function getUserStatus(membershipData) {
  if (membershipData?.active && membershipData?.stopDate) {
    return 'rejoin'
  }
  if (membershipData?.active && !membershipData?.stopDate) {
    return 'active'
  }
  return 'non-member'
}

export function getModalFooter(status) {
  switch (status) {
    case 'active':
      return ActiveFooter
    case 'rejoin':
      return RejoinFooter
    default:
      return DefaultFooter
  }
}

export function formatMembershipDate(date) {
  return moment(date).format('MMMM DD')
}
